/**
 * TinyMCE `init` for the submit message editor on Add/Edit Form.
 * Keeps addForm.js smaller; behavior matches previous inline config.
 */
export function buildSubmitMessageTinyMceInit(handleFileChange) {
  return {
    height: 300,
    menubar: true,
    statusbar: false,
    branding: false,
    resize: true,
    browser_spellcheck: true,
    contextmenu: false,
    plugins:
      "preview importcss searchreplace autolink autosave save directionality code visualblocks visualchars fullscreen image link media template codesample table charmap pagebreak nonbreaking anchor insertdatetime advlist lists wordcount help charmap emoticons fontselect",
    toolbar:
      "undo redo | bold italic underline strikethrough | formatselect | fontselect | fontsizeselect | fontfamily fontsize blocks | alignleft aligncenter alignright alignjustify | indent outdent | bullist numlist | forecolor backcolor removeformat | pagebreak | charmap emoticons | fullscreen  preview print | insertfile image media template link anchor codesample | ltr rtl | table | code ",
    toolbar_mode: "sliding",
    fontsize_formats: "8pt 10pt 12pt 14pt 18pt 24pt 36pt",
    forced_root_block: "p",
    newline_behavior: "block",
    autosave_ask_before_unload: false,
    image_title: true,
    file_picker_types: "image",
    file_picker_callback(cb, value, meta) {
      const input = document.createElement("input");
      input.setAttribute("type", "file");
      input.setAttribute("accept", "image/*");
      input.onchange = function () {
        const fileData = this?.files;
        setTimeout(() => {
          handleFileChange(fileData, cb);
        }, 10);
      };
      input.click();
    },
    content_style: "* { margin: 0.02rem; line-height: 1.5; }",
  };
}
